import { Alert, Slide, Snackbar } from "@mui/material";
import zIndex from "@mui/material/styles/zIndex";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export const withSnackbar = (WrappedComponent) => {
  return (props) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [severity, setSeverity] = useState("success");
    const [duration,setDuration] = useState(2000)

    const showMessage = (toastMessage, toastSeverity,toastDuration) => {
      setMessage(toastMessage);
      setSeverity(toastSeverity);
      setOpen(true);
      setDuration(toastDuration);
    };
    const handleClose = () => {
      setOpen(false);
    };
    return (
      <>
        <WrappedComponent {...props} showToast={showMessage} />
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          autoHideDuration={duration}
          open={open}
          onClose={() => handleClose()}
          TransitionComponent={Slide}
          style={{zIndex: 1503}}
        >
          <Alert variant="filled" onClose={handleClose} severity={severity}>
            {t(message)}
          </Alert>
        </Snackbar>
      </>
    );
  };
};

